/*
 * @Author: 田鑫
 * @Date: 2022-04-15 11:16:36
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-04-15 11:22:57
 * @Description: 对账管理
 */

export default [
  {
    name: "wuMei",
    path: "/supplySystem/:supplyId/accountCheckingManagement/wuMei",
    meta: { title: "物美对账" },
    component:
      require("business/supplySystem/accountCheckingManagement/wuMei.vue")
        .default,
  },
  {
    name: "rongTong",
    path: "/supplySystem/:supplyId/accountCheckingManagement/rongTong",
    meta: { title: "融通对账" },
    component:
      require("business/supplySystem/accountCheckingManagement/rongTong.vue")
        .default,
  },
  {
    name: "keJiWei",
    path: "/supplySystem/:supplyId/accountCheckingManagement/keJiWei",
    meta: { title: "科技委对账" },
    component:
      require("business/supplySystem/accountCheckingManagement/keJiWei.vue")
        .default,
  },
];
